import { useUserMonthlyReportDataQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import type { Store } from "../store";

export const useFetchTableData = (store: Store): boolean => {
  const { loading } = useUserMonthlyReportDataQuery({
    notifyOnNetworkStatusChange: true,
    variables: store.queryVariables,
    onCompleted(data) {
      store.setTableData(data);
    },
    ...onError(),
  });

  return loading;
};
